import { render, staticRenderFns } from "./bulkUpload.vue?vue&type=template&id=31c1a710"
import script from "./bulkUpload.vue?vue&type=script&lang=js"
export * from "./bulkUpload.vue?vue&type=script&lang=js"
import style0 from "./bulkUpload.vue?vue&type=style&index=0&id=31c1a710&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports